import { RequsetLeadTimeData } from "../type-definitions";
import DesktopRequestDetailsSection from "./desktop-request-details-section";
import MobileRequestDetailsSection from "./mobile-request-details-section";

function RequestDetailsSection({
  requestDetails
}: {
  requestDetails: RequsetLeadTimeData;
}) {
  return (
    <div
      data-testid="request-details-section"
      className="bg-ciq-neutral-50 max-h-full"
    >
      <div data-testid="request-details-section-mobile" className="md:hidden">
        <MobileRequestDetailsSection requestDetails={requestDetails} />
      </div>
      <div
        data-testid="request-details-section-desktop"
        className="hidden md:block"
      >
        <DesktopRequestDetailsSection requestDetails={requestDetails} />
      </div>
    </div>
  );
}

export default RequestDetailsSection;
